/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".message[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:80px;color:rgba(150,168,192,.6)}.message__icon[_ngcontent-%COMP%]{margin:40px;font-size:90px}.message__text[_ngcontent-%COMP%]{font-size:16px;line-height:20px;text-align:center;font-weight:300;color:rgba(150,168,192,.8)}"];
export { styles as styles };
